module.exports = {"helmetTitle":"Veloe - Cancelar plano","label":"Cancelar plano","optionsSubtitle":"Por que você quer cancelar seu plano?","modal":{"title":"Enviamos um código para você.","description":"Para fazer o bloqueio, coloque aqui o código que a gente enviou para o celular final (00) xxxxx-xx00.","buttonText":"ok","label":"Código","placeholder":"Ex 0000000","fetchErrorMessage":"O código não é esse. Tente de novo.","refreshMessage":"Reenviamos um código para você."},"planType":{"pos":"pós","pre":"pré"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/CancelPlanMotive/data.json
// module id = 2157
// module chunks = 0